import React, { Component } from 'react';
import Reveal from '../../reveal';
import RevealEdges from '../../animations/reveal-edges';
import PropTypes from 'prop-types';
import ProjectBlurb from '../project-blurb';
import { css } from 'emotion';
import styles from './project-video-loop.module.css';

const ProjectVideo = props => {
  const { isInView } = props;
  if (isInView !== true) {
    return (
      <Reveal>
        <ProjectVideoContent {...props} />
      </Reveal>
    );
  } else {
    return <ProjectVideoContent {...props} />;
  }
};

class ProjectVideoContent extends Component {
  constructor() {
    super();
    this.state = {
      playerOne: null,
    };
  }

  videosRefs = [{ name: 'videoOne' }];

  componentDidMount() {
    const VimeoPlayer = require('@vimeo/player');
    this.setState({
      playerOne: new VimeoPlayer(this.refs[0]),
    });
  }

  render() {
    const {
      background,
      muted,
      videoId,
      wrapperPadding,
      blurb,
      isInView,
      autoplay,
      hideBlurb,
    } = this.props;

    return (
      <React.Fragment>
        <div
          className={css`
            padding: ${wrapperPadding};
            position: relative;
          `}
        >
          <RevealEdges isInView={isInView} />
          <div className={styles.videoWrapper}>
            <div
              className={styles.video}
              data-vimeo-id={videoId}
              data-vimeo-autoplay={autoplay}
              data-vimeo-muted={muted}
              data-vimeo-maxwidth="1219"
              data-vimeo-maxheight="700"
              data-vimeo-title="0"
              data-vimeo-background={background}
              ref={0}
            />
          </div>
          {hideBlurb !== true && <ProjectBlurb blurb={blurb} />}
        </div>
      </React.Fragment>
    );
  }
}

ProjectVideo.propTypes = {
  background: PropTypes.string,
  muted: PropTypes.string,
  videoId: PropTypes.string,
  wrapperPadding: PropTypes.string,
  blurb: PropTypes.string,
  isInView: PropTypes.bool,
};

export default ProjectVideo;



// WEBPACK FOOTER //
// ./src/components/project/project-video-loop/index.js